import { render, staticRenderFns } from "./SisImportProviderOverview.vue?vue&type=template&id=5d89de23&scoped=true&"
import script from "./SisImportProviderOverview.vue?vue&type=script&lang=js&"
export * from "./SisImportProviderOverview.vue?vue&type=script&lang=js&"
import style0 from "./SisImportProviderOverview.vue?vue&type=style&index=0&id=5d89de23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d89de23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VIcon,VImg,VRow,VSkeletonLoader})
